import React from 'react';

const Profile = ({ children }) => {
  return <div>{children}</div>;
};

export default Profile;
